<template>
  <div id="locale">
    <div class="locale">
      <input id="chkFrench" type="checkbox" :checked="locale == 'fr'" @click="setLocale('fr', $event)">
      <label for="chkFrench" @click="setLocale('fr', $event)">Français</label>
    </div>
    <div class="locale">
      <input id="chkEnglish" type="checkbox" :checked="locale == 'en'" @click="setLocale('en', $event)">
      <label for="chkEnglish" @click="setLocale('en', $event)">English</label>
    </div>
    <div class="buttons">
      <div class="btn btn-secondary" @click="back">{{ $t("navigation.back") }}</div>
      <div class="btn btn-primary" @click="apply">{{ $t("navigation.apply") }}</div>
    </div>
  </div>
</template>

<script>

  import Configuration from '../../core/Configuration';
  import moment from "moment";

  export default {

    name: "locale",

    data() {
      return {
        locale: this.$ts.state.locale
      };
    },

    mounted() {
      this.$store.commit("setDisplay", {
        showHeader: true,
        showHeaderLeft: true,
        showFooter: true,
        headerTitle: "locale.title",
        headerIcon: "/svg/settings.svg"
      });
    },

    methods: {
      back() {
        window.history.back();
      },
      setLocale(locale, e) {
        this.locale = locale;
        e.stopPropagation();
        e.preventDefault();
      },
      apply() {
        this.$ts.commit("setLocale", this.locale);
        Configuration.write("locale", this.locale);
        moment.locale(this.locale);
        this.back();
      }
    }

  }

</script>

<style lang="scss" scoped>

  #locale {
    background-color: #f2f3f4;
    padding: 20px;
  }

  .locale {
    padding-bottom: 20px;
    border-bottom: 1px solid #d9dcde;
    margin-bottom: 20px;
  }

  .buttons {
    display: flex;
    .btn {
      flex-grow: 1;
      flex-basis: 0;
      &:not(:last-of-type) {
        margin-right: 20px;
      }
    }
  }

</style>